import {Injectable, signal} from '@angular/core';

export interface UploadedFile {
  id: string;
  name: string;
  size: number;
  type: string;
  preview: string | null;
  progress: number;
  /**
   * 'staged' - picked, not yet submitted. 'processing' covers the single request that
   * sends the file and scans it (the client cannot observe upload vs. scan separately).
   */
  status: 'staged' | 'processing' | 'ready' | 'error';
  error: string | null;
  /**
   * Whether retrying the same file could succeed. This is a UI-only field: the backend
   * does not send a `retryable` value. It is computed locally by `isRetryable` in
   * upload.ts from the HTTP status and ProblemDetails `type` of a failed response.
   */
  retryable: boolean;
}

@Injectable({providedIn: 'root'})
export class ClientActionService {
  readonly token = signal<string | null>(null);
  readonly instructions = signal<string | null>(null);
  readonly expiresAt = signal<Date | null>(null);
  readonly uploadToken = signal<string | null>(null);
  readonly uploadTokenExpiresAt = signal<Date | null>(null);
  readonly verified = signal<{ lastName: string } | null>(null);
  readonly files = signal<UploadedFile[]>([]);
  readonly submittedAt = signal<Date | null>(null);
  readonly request = signal<string | null>(null);
  readonly loanNumber = signal<string | null>(null);
  readonly clientName = signal<string | null>(null);


  setToken(token: string, instructions: string | null, expiresAt: Date) {
    this.token.set(token);
    this.instructions.set(instructions);
    this.expiresAt.set(expiresAt);
  }

  setUploadToken(uploadToken: string, expiresAt: Date | null) {
    this.uploadToken.set(uploadToken);
    this.uploadTokenExpiresAt.set(expiresAt);
  }

  markVerified(lastName: string) {
    this.verified.set({ lastName });
  }

  setRequest(request: string | null) {
    console.log('request from cas', request);
    this.request.set(request);
  }

  setLoanNumber(ln: string) {
    console.log('loan number', ln);
    this.loanNumber.set(ln)
  }

  setClientName(cn: string) {
    console.log('client name', cn);
    this.clientName.set(cn)
  }

  setFiles(files: UploadedFile[]) {
    this.files.set(files);
  }

  markSubmitted() {
    this.submittedAt.set(new Date());
  }

  reset() {
    this.verified.set(null);
    this.files.set([]);
    this.submittedAt.set(null);
    this.request.set(null);
  }
}
